import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CalendarPlus, Mail } from "lucide-react";

interface CustomerActionsProps {
  blocked: boolean;
  toggleBlock: unknown;
  deleteCustomer: unknown;
  onClose: () => void;
}

// UPPDRAG-30: empty destructuring (no props consumed yet) — props type declared
// for future use; underscore arg keeps ESLint happy.
export default function CustomerActions(_props: CustomerActionsProps) {
  const { t } = useTranslation("admin");
  return (
    <div className="sticky bottom-0 bg-background border-t pt-3 pb-1 -mx-6 px-6 mt-4">
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" size="sm" className="gap-1 text-xs">
          <Mail className="h-3.5 w-3.5" />
          {t("customer.actions.sendMessage")}
        </Button>
        <Button variant="outline" size="sm" className="gap-1 text-xs">
          <CalendarPlus className="h-3.5 w-3.5" />
          {t("customer.actions.createBooking")}
        </Button>
      </div>
    </div>
  );
}
